import React from 'react';
import * as PropTypes from 'prop-types'
import {
  dollarsWithoutCents, priceWithoutDollar,
} from '../../../helpers/ApplicationHelper';

const Stat = ({stat,worthStat , attr}) => {
  const number = stat.name.indexOf('estimation') !== -1 ? dollarsWithoutCents(worthStat) : priceWithoutDollar(worthStat);

  return (
      <div {...attr}>
        <div className={'img-icon ' + (stat.iconClass)}/>
        <div className="content">
          <div className="number">{number}</div>
          <div className="text">{stat.text}</div>
        </div>
      </div>
  )
};

Stat.propTypes = {
  stat:PropTypes.object,
  worthStat:PropTypes.number,
  attr:PropTypes.object
};

Stat.defaultProps = {
  stat:{iconClass:'ring',text:'',name:''},
  worthStat:0,
  attr:{}
};

export default Stat;